import { gql } from '@apollo/client';

export const SAVE_USER = gql`
  mutation saveUser($input: UserInput!) {
    saveUser(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const RESET_PASSWORD = gql`
  mutation resetUserPassword($id: Int!) {
    resetUserPassword(id: $id) {
      commandId
      correlationId
    }
  }
`;
